import { ResourceOrderFormActions } from 'Manifest/ResourceOrderFormActions';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';

export const Dcrm = (props) => {
  const {
    handleSubmit,
    incidentNameError,
    IncidentNumError,
    resourceNameError,
    onChange,
    form,
    sup_name,
    sphone,
    curDate,
    formatDate,
    crewOptions,
    vehicleOptions,
    saveBtn,
    disablePrevious,
    previous,
    saved_id,
    manifest_id,
    handleOnUpload,
    handleDeleteRof,
    handleOnViewResourceOrderForm,
    handleEditRof,
    saveConfirmOpenModal,
    pointOfHireError,
    jobLocError,
    estStartError,
    estFinishError,
    submitClick,
    manifestType,
    printManifest,
    viewOnly = false,
  } = props;

  const { handleEstimateStartDates, handleEstimateFinishDates } = props;

  return (
    <div id='finalize_manifest' className='dcrm print_manifest_wrap'>
      <h2>{viewOnly ? 'View' : 'Finalize'} Manifest</h2>
      <form id='form5' onSubmit={handleSubmit}>
        <fieldset disabled={viewOnly}>
          <div id='view_printing_page'>
            <div
              className='responsive_table dcrm_view_manifest'
              id='view_general_information_table'
            >
              <div className='table top_table'>
                <div className='tr'>
                  <div className='print_center td top_title' colSpan='5'>
                    <h3>DEER CREEK RESOURCES MANIFEST FORM</h3>
                  </div>
                </div>
                <div className='tr'>
                  <div className='td' data-header-title='Incident Name'>
                    <h4>Incident Name</h4>
                    <input
                      type='text'
                      errors={incidentNameError}
                      placeholder='Fill...'
                      id={'incidentName' + manifestType}
                      name='incident_name'
                      value={form.incident_name}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Incident Number'>
                    <h4>Incident Number</h4>
                    <input
                      type='text'
                      errors={IncidentNumError}
                      placeholder='Fill...'
                      id={'incidentNumber' + manifestType}
                      name='incident_number'
                      value={form.incident_number}
                      onChange={onChange}
                    />
                  </div>
                  {/*<div className="tdw-15 td"></div>*/}
                  <div
                    className='td_split td'
                    data-header-title='Resource Number'
                  >
                    <h4>Resource</h4>
                    <b>E-</b>{' '}
                    <span>
                      <input
                        type='text'
                        errors={resourceNameError}
                        placeholder='Fill...'
                        id='resource5'
                        name='resource'
                        value={form.resource}
                        onChange={onChange}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className='table top_table no_border'>
                <div className='tr contrac5'>
                  <div
                    className='td'
                    data-header-title='Contractor Represntative'
                  >
                    <h4>Contractor Represntative</h4>
                    <p id='sup_det_view'>{sup_name}</p>
                  </div>
                  {/*<div className="tdw-15 td"></div>*/}
                  <div
                    className='td'
                    data-header-title='Representative Phone Number'
                  >
                    <h4>Representative Phone Number</h4>
                    <p id='sup_phone_view'>{sphone}</p>
                  </div>
                </div>
                <div className='tr contrac5'>
                  <div className='td' data-header-title='Point of Hire'>
                    <h4>Point of Hire</h4>
                    <input
                      type='text'
                      errors={pointOfHireError}
                      placeholder='Fill...'
                      id='pointOfHire5'
                      name='point_of_hire'
                      value={form.point_of_hire}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Job Location'>
                    <h4>Job Location</h4>
                    <input
                      type='text'
                      errors={jobLocError}
                      placeholder='Fill...'
                      id='jobLoc5'
                      name='job_loc'
                      value={form.job_loc}
                      onChange={onChange}
                    />
                  </div>
                  {/*<div className="tdw-15 td"></div>*/}
                  <div className='td' data-header-title='Estimated Duration'>
                    <h4>Estimated Duration</h4>
                    <div className='duration_date_wrap'>
                      <div className='manifesttDateWrapper'>
                        <DatePicker
                          name='est_start'
                          placeholderText='Start'
                          dateFormat='MM/DD/YYYY'
                          popperPlacement='bottom-end'
                          selected={
                            form.est_start ? moment(form.est_start) : null
                          }
                          onChange={handleEstimateStartDates}
                          errors={estStartError}
                          id='estStart5'
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                      </div>
                      <span className='to'>To</span>
                      <div className='manifesttDateWrapper'>
                        <DatePicker
                          name='est_finish'
                          placeholderText='Finish'
                          dateFormat='MM/DD/YYYY'
                          popperPlacement='bottom-end'
                          selected={
                            form.est_finish ? moment(form.est_finish) : null
                          }
                          onChange={handleEstimateFinishDates}
                          errors={estFinishError}
                          id='estFinish5'
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='responsive_table'>
              <div
                className='table top_table table_space ifca_employee_details'
                id='view_employee_details_table'
              >
                <p className='mobile_crew'>Crew Details</p>
                <div className='thead'>
                  <div className='tr'>
                    <div
                      className='print_center th'
                      data-header-title='Crew Member Name'
                    >
                      <h4>Employee Name (Last, First)</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='M'
                    >
                      <h4>M</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='F'
                    >
                      <h4>F</h4>
                    </div>
                    <div
                      className='print_center crew_mem_no th'
                      data-header-title='Employee Id Number'
                    >
                      <h4>
                        Employee Id
                        <br />
                        Number
                      </h4>
                    </div>
                    <div
                      className='print_center th'
                      data-header-title='Project Position'
                    >
                      <h4>Project Position</h4>
                    </div>
                    <div
                      className='print_center th phone'
                      data-header-title='Phone Number'
                    >
                      <h4>
                        Phone <br /> Number
                      </h4>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{crewOptions}</div>
              </div>
            </div>
            <div className='responsive_table view_driver_vehicle_div'>
              <h3 className='inner_head_title'>
                Driver and Vehicle Information
              </h3>
              <div
                className='table top_table no_border ifca_driver_vehicle_table'
                id='view_driver_vehicle_table'
              >
                <div className='thead'>
                  <div className='tr'>
                    <div className='td no_border_td_right'>
                      <h6>Driver Name (Last, First)</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Driver License No</h6>
                    </div>
                    <div className='td no_border_td_right mdate DLIssued'>
                      <h6>ST</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Exp. Date</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Vehicle License No</h6>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{vehicleOptions}</div>
              </div>
            </div>

            <div className='table top_table last_table ncc_sign'>
              <div className='tr'>
                <div className='td'>
                  <span className='title_bottom'>
                    Crew Leader Represntative (Print)
                  </span>
                  <br />
                  <p id='sup_det_create'>{sup_name}</p>
                </div>
                <div className='td date'>
                  <span className='title_bottom'>Date</span>
                  <br />
                  <p className='print_date'>{formatDate(curDate)}</p>
                </div>
                <div className='td'>
                  <span className='title_bottom'>Contact Phone Number</span>
                  <br />
                  <p id='sup_phone_create'>{sphone}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='clearFix' />
          <div className='gear-option-btn-wrap'>
            {!viewOnly && (
              <>
                <input
                  type='button'
                  className='button hide_view_manifest'
                  disabled={disablePrevious}
                  onClick={previous}
                  value='Previous'
                />
                <input
                  type='button'
                  className='button hide_view_manifest'
                  onClick={() => window.location.reload()}
                  disabled={disablePrevious}
                  value='Cancel'
                />
                {(saved_id || manifest_id) && (
                  <>
                    <input
                      type='submit'
                      id='to_view_final_print'
                      disabled={saveBtn}
                      className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                      name='print'
                      onClick={submitClick}
                      value='Print Manifest'
                    />
                    <input
                      type='submit'
                      id='to_view_final_email'
                      name='email'
                      disabled={saveBtn}
                      className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                      onClick={submitClick}
                      value='Email Manifest'
                    />
                  </>
                )}
                <ResourceOrderFormActions
                  enableViewButton={form.resource_order_form}
                  handleOnUpload={handleOnUpload}
                  handleDeleteRof={handleDeleteRof}
                  handleOnView={handleOnViewResourceOrderForm}
                  handleOnEdit={handleEditRof}
                  disabled={saveBtn}
                  viewOnly={viewOnly}
                />
                <input
                  type='button'
                  disabled={saveBtn}
                  className={`button save_manifest ${saveBtn ? 'btn-disabled' : ''}`}
                  name='save'
                  onClick={saveConfirmOpenModal}
                  value='Save'
                />
                {saveBtn && (
                  <img
                    className='login_loader'
                    alt='loader'
                    src='data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=='
                  />
                )}
              </>
            )}
          </div>
        </fieldset>
        {viewOnly && (
          <div className='gear-option-btn-wrap'>
            <input
              type='button'
              id='to_view_final_print'
              className={`button save_manifest`}
              name='print'
              onClick={printManifest}
              value='Print Manifest'
            />
            {form.resource_order_form && (
              <input
                type='button'
                id='view_ROF'
                onClick={() => handleOnViewResourceOrderForm()}
                value='View RO'
                name='view_ROF'
                className={`button save_manifest}`}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};

Dcrm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  handleEstimateStartDates: PropTypes.func.isRequired,
  handleEstimateFinishDates: PropTypes.func.isRequired,
  submitClick: PropTypes.func.isRequired,
  saveConfirmOpenModal: PropTypes.func.isRequired,
  previous: PropTypes.func,
  disablePrevious: PropTypes.bool,
  saveBtn: PropTypes.bool,
  saved_id: PropTypes.any,
  manifest_id: PropTypes.any,
  viewOnly: PropTypes.bool,
  manifestType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  printManifest: PropTypes.func,

  sup_name: PropTypes.string,
  sphone: PropTypes.string,
  curDate: PropTypes.any,
  formatDate: PropTypes.func.isRequired,

  crewOptions: PropTypes.node,
  vehicleOptions: PropTypes.node,

  incidentNameError: PropTypes.any,
  IncidentNumError: PropTypes.any,
  resourceNameError: PropTypes.any,
  pointOfHireError: PropTypes.any,
  jobLocError: PropTypes.any,
  estStartError: PropTypes.any,
  estFinishError: PropTypes.any,

  form: PropTypes.shape({
    incident_name: PropTypes.string,
    incident_number: PropTypes.string,
    resource: PropTypes.string,
    point_of_hire: PropTypes.string,
    job_loc: PropTypes.string,
    est_start: PropTypes.any,
    est_finish: PropTypes.any,
    resource_order_form: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        resource_order_form_type: PropTypes.number,
      }),
    ]),
  }).isRequired,

  handleOnUpload: PropTypes.func.isRequired,
  handleDeleteRof: PropTypes.func.isRequired,
  handleOnViewResourceOrderForm: PropTypes.func.isRequired,
  handleEditRof: PropTypes.func.isRequired,
};